import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { DropzoneBox } from './style';

type Props = {
  setFile: Dispatch<SetStateAction<File | undefined>>;
  setErrorMessages: Dispatch<SetStateAction<string[]>>;
  disabled?: boolean;
};

const Dropzone = ({ setFile, setErrorMessages, disabled }: Props) => {
  const { t } = useTranslation();
  const dropzone = useDropzone({
    disabled,
    multiple: false,
    accept: {
      accept: ['jpg', 'jpeg', 'png'].map((item) => '.' + item),
    },
  });

  useEffect(() => {
    if (dropzone.acceptedFiles) {
      setFile(dropzone.acceptedFiles[0]);
      setErrorMessages([]);
    }
  }, [dropzone.acceptedFiles]);

  useEffect(() => {
    if (dropzone.fileRejections) {
      dropzone.fileRejections.map(({ errors }) =>
        errors.map((error) =>
          setErrorMessages((errorMessages) => [...errorMessages, error.message]),
        ),
      );
    }
  }, [dropzone.fileRejections]);

  return (
    <div>
      <DropzoneBox {...dropzone.getRootProps({})}>
        <input id="dropzone" {...dropzone.getInputProps()} />
        <div>
          <p style={{ color: '#000000DE' }}>{t('resident_document_management_upload_document')}</p>
          <p style={{ color: '#000000DE' }}>{t('profile_picture_modal_aspect_ratio_text')}</p>
        </div>
      </DropzoneBox>
    </div>
  );
};

export default Dropzone;
